export default __webpack_public_path__ + "static/media/oops-no-image.8e317f22.jpg";